import React from 'react';
import styled from 'styled-components';
import { minBp, maxBp } from '../../lib/theme';
import Magnify from './Magnify';

export const Wrap = styled.div`
  ${({ isFullScreen, isBikeSummary }) => `
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    background: #fff;
    padding: 10px;

    @media ${minBp('tabletLarge')} {
      display: flex;
      padding: 0;
    }

    @media ${minBp('desktop')} { 
      min-height: auto;
      height: ${isFullScreen ? '100%' : 'auto'};
      padding: 0;
      overflow: hidden;
    }

    ${
      isBikeSummary && !isFullScreen
        ? `
      @media ${minBp('desktop')} {
        min-height: 100%;


        min-height: 70vh;
      }
    `
        : ``
    }
  `}
`;

export const ImageWrap = styled(Magnify)`
  ${({ isFullScreen, isBikeSummary, backButton }) => `
  height: 100%;
  margin: 0 auto ${isBikeSummary ? '70px' : 0};
  position: relative;

  ${
    backButton
      ? `
    margin-top: ${isBikeSummary ? 0 : '30px'};
  `
      : ``
  }

  @media ${minBp('desktop')} {
    height: ${isFullScreen ? '90%' : '100%'};
    width: 70%;
    margin: 70px auto;
    padding: 0;

    ${
      isBikeSummary && !isFullScreen
        ? `
      min-height: 100%;
    `
        : ``
    }
  }

  @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) { 
    ${
      isBikeSummary && !isFullScreen
        ? `
      min-height: 70vh !important;
    `
        : ``
    }
  }
`}
`;

export const TitleWrap = styled.div`
  ${({ isFullScreen, backStep, lensOn, headerHeight }) => `
    z-index: ${lensOn ? 97 : 102};
    width: ${isFullScreen ? '100%' : 'auto'};
    margin-top: ${isFullScreen ? '40px' : 0};
    position: sticky;

    &.is-pinned {
    top: ${headerHeight};
    }

    &.is-unpinned {
      top: 0;
    }

    @media ${minBp('tablet')} { 
      margin-left: ${isFullScreen ? '0px' : '30px'};
      margin-top: ${isFullScreen ? '5px' : '15px'};
    }

    @media ${minBp('desktop')} { 
      position: absolute;
      top: ${isFullScreen ? '60px' : '37px'};
      margin-left: ${isFullScreen ? '0' : '120px'};
      display: flex;

      ${
        backStep
          ? `
        margin-left: 60px;
        top: 50px;
      `
          : ``
      }
    }
  `}
`;

export const Title = styled.h3`
  ${({ isFullScreen, backStep }) => `
    display: ${isFullScreen ? 'block' : 'none'};
    text-transform: uppercase;
    margin-bottom: 0;
    width: ${isFullScreen ? '100%' : 'auto'}
    text-align: ${isFullScreen ? 'center' : 'initial'}
    margin-top: 10px;
    padding: ${backStep ? '0 0 0 50px' : 0};
    cursor: ${backStep ? 'pointer' : 'default'};

    @media ${minBp('tablet')} { 
      margin-top: ${isFullScreen ? '10px' : '65px'};
    }

    @media ${minBp('tabletLarge')} { 
      margin-top: ${isFullScreen ? '20px' : '65px'};
    }

    @media ${minBp('desktop')} {
      display: ${backStep ? 'none' : 'block'};
      line-height: 32px;
      margin-top: 0;
      padding: ${backStep ? '0 0 0 20px' : 0};
    }
  `}
`;

export const BackButton = styled.div`
  ${({ canGoBack, isWindows, isFullScreen }) => `
    display: ${isFullScreen ? 'none' : 'inline-block'};
    padding: 10px;
    z-index: 99;
    line-height: 1;
    cursor: pointer;
    
    svg {
      width: 12px;
      height: 12px;
      position: relative;
      top: ${isWindows ? '3px' : '1px'};
    }

    @media ${minBp('desktop')} {
      padding: 0;
      display: none;

      ${
        canGoBack
          ? `
        display: block;
      `
          : ``
      }
      
      svg {
        position: relative;
        top: -2px;
        vertical-align: middle;
        width: 18px;
        height: 18px;
        z-index: 10000;
        margin-right: 8px;
      }
    }

    @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) { 
      margin-top: 2px;
    }
`}
`;

export const BackButtonInner = styled.div`
  border: 1px solid #dad9d7;
  border-radius: 2px;
  padding: 4px 5px 2px 4px;
  background-color: rgba(255, 255, 255, 0.75);

  @media ${minBp('desktop')} {
    border: 0;
    padding: 0;
  }
`;

export const BackLabel = styled.span`
  font-size: 14px;
  font-family: ${({ theme }) => theme.fonts.dinDemi};
  text-transform: uppercase;
  line-height: 0;
  color: #000;

  @media ${minBp('desktop')} {
    font-size: 20px;
  }
`;

export const BikeButtonWrapper = styled.div`
  position: relative;
  @media ${minBp('desktop')} {
    position: static;
  }
`;

export const BikeButtonContainer = styled.div`
  ${({ isFullScreen, isBikeSummary, active, buttonLength }) => `
    display: flex;
    justify-content: space-between;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: ${isFullScreen ? '-40px' : '-20px'};
    min-width: 100px;
    z-index: 102;

    ${
      isBikeSummary
        ? `
      bottom: 0px;
    `
        : ``
    }

    @media ${minBp('tablet')} {
      bottom: ${isFullScreen ? '-50px' : '-25px'};
    }

    @media ${minBp('tabletLarge')} {
      bottom: ${isFullScreen ? '-50px' : '-25px'};
    }

    @media ${minBp('desktop')} {
      bottom: ${isFullScreen ? '50px' : '25px'};
      z-index: ${active ? 97 : 98};
      
      ${
        isBikeSummary && !isFullScreen
          ? `
        bottom: 0;
      `
          : ``
      }
    }

    @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) { 
      min-width: ${(buttonLength - (isFullScreen ? 1 : 0)) * 75}px;
    }
  `}
`;

export const Button = styled.button`
  background: #000;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  height: 40px;
  width: 40px;
  cursor: pointer;
  padding: 0;

  @media ${minBp('tablet')} {
    height: 48px;
    width: 48px;
  }

  @media ${minBp('desktop')} {
    &:hover {
      & + span {
        opacity: 1;
        transition: opacity 0.2s ease-out;
      }
    }
  }
`;

export const ButtonLabel = styled.span`
  ${({ isBikeSummary }) => `
    display: ${isBikeSummary ? 'block' : 'none'};
    margin-top: 6px;
    font-size: 13px;
    line-height: 22px;
    color: black;

    @media ${minBp('desktop')} {
      display: block;
      margin-top: ${isBikeSummary ? '10px' : '4px'};
      opacity: ${isBikeSummary ? 1 : 0};
    }
  `}
`;

export const Icon = styled.img`
  height: 20px;
  width: auto;

  @media ${minBp('tablet')} {
    height: 26px;
  }
`;

export const ButtonWrap = styled.div`
  display: ${({ hideOnMobile }) => (hideOnMobile ? 'none' : 'flex')};
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1 1 0px;
  margin: 0 12px;

  @media ${minBp('desktop')} {
    min-width: ${({ isFullScreen }) => (isFullScreen ? '50px' : 'auto')};
    display: flex;
    margin: 0 15px;
  }

  @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
    display: ${({ isFullScreen, isZoomButton }) => (isFullScreen && isZoomButton ? 'none' : 'flex')};
  }
`;

export const SummaryToggle = styled.button`
  ${({ theme }) => `
    margin: 25px 0 0px;
    text-transform: uppercase;
    line-height: 1.25;
    font-family: ${theme.fonts.dinDemi};
    font-size: 12px;
    text-align: center;
    appearance: none;
    background: transparent;
    border: 0;
    border-bottom: 1px solid ${theme.colors.hairline};
    padding: 15px 0;
    width: 100%;

    svg {
      width: 13px;
      height: 13px;
      vertical-align: middle;
      position: relative;
      bottom: 2px;
      margin-left: 5px;
    }

    @media ${minBp('tablet')} {
      margin: 45px 0 0px;

    }

    @media ${minBp('desktop')} {
      display: none;
    }
  `}
`;
